import React from "react";
import TableLoaderEffect from "../../../constant/TableLoader";
const maxWidthStyle300 = {
  maxWidth: "30rem",
  minWidth: "10rem",
  whiteSpace: "normal",
  display: "block",
};

const ManualArchivePage = ({
  selectedManuals,
  manualList,
  isLoading,
  toggleCheckbox,
  handleSelectAll,
  navigate,
}) => {
  return (
    <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
      <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
        <table
          id="empoloyees-tblwrapper"
          className="table ItemsCheckboxSec dataTable no-footer mb-0"
        >
          <thead>
            <tr>
              <th>
                <div className="form-check custom-checkbox checkbox-primary">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={
                      selectedManuals.length === manualList.length &&
                      manualList.length !== 0
                    }
                    onChange={handleSelectAll}
                  />
                </div>
              </th>
              <th>Manual Number</th>
              <th>Department</th>
              <th>Unit</th>
              <th>Supplier</th>
              <th>Package Number</th>
              <th>Letter Number</th>
              <th>Registration Date</th>
              <th>Status</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
              <TableLoaderEffect colLength={6} />
              </tr>
            ) : (
              manualList.map((item, index) => (
                <tr key={index}>
                  <td>
                    <div className="form-check custom-checkbox checkbox-primary">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={selectedManuals.includes(item.id)}
                        onChange={() => toggleCheckbox(item.id)}
                      />
                    </div>
                  </td>
                  <td>
                    <span
                      onClick={() => navigate(`/documents/${item.id}`)}
                      className="text-primary cursor-pointer fw-bolder"
                    >
                      {item.manual_no}
                    </span>
                  </td>
                  <td>{item.department?.name || ""}</td>
                  <td>{item.unit?.name || ""}</td>
                  <td>{item.supplier}</td>
                  <td>{item.package_no}</td>
                  <td>{item.letter_no}</td>
                  <td>{item.registration_date}</td>
                  <td>
                    {item.is_approved === true ? (
                      <span
                        className={`badge light border-0 badge-success badge-sm`}
                      >
                        Approved
                      </span>
                    ) : (
                      <span
                        className={`badge light border-0 badge-info badge-sm`}
                      >
                        Pending
                      </span>
                    )}
                  </td>
                  <td>
                    <span style={maxWidthStyle300}> {item.description} </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ManualArchivePage;
